// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BI v2 teyit ekranı (/bi-demo) */

.bi-demo .bi-kpi-kart {
  height: 100%;
  border-top: 3px solid var(--bi-renk, #8c8c8c);
  cursor: pointer;
  transition: box-shadow 0.15s ease;
}
.bi-demo .bi-kpi-kart.pasif {
  cursor: default;
  opacity: 0.75;
}
.bi-demo .bi-kpi-kart.secili {
  box-shadow: 0 0 0 2px var(--bi-renk, #1677ff);
}
.bi-demo .bi-kpi-baslik {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  margin-bottom: 6px;
}
.bi-demo .bi-kpi-tutar {
  font-size: 19px;
  font-weight: 600;
  line-height: 1.3;
  font-variant-numeric: tabular-nums;
  word-break: break-word;
}
.bi-demo .bi-nokta {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex: none;
}
.bi-demo .bi-panel {
  border-top: 3px solid var(--bi-renk, #8c8c8c);
}

/* Süzgeçler */
.bi-demo .bi-suzgec {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.bi-demo .bi-suzgec-ad {
  font-size: 11px;
  color: #8c8c8c;
  line-height: 1.2;
}
.bi-demo .bi-suzgec-cubugu {
  padding: 10px;
  margin-bottom: 8px;
  border-radius: 8px;
  background: #f7f9fb;
  border: 1px solid #eef0f2;
}
.bi-demo .bi-etiketler {
  margin-top: 8px;
}
body.dark-theme .bi-demo .bi-suzgec-cubugu {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.08);
}

/* Özet: yatay çubuklar (ilk 15 grup) */
.bi-demo .bi-cubuk-kutu {
  padding: 10px;
  border: 1px solid #eef0f2;
  border-radius: 10px;
}
body.dark-theme .bi-demo .bi-cubuk-kutu {
  border-color: rgba(255, 255, 255, 0.08);
}
.bi-demo .bi-cubuk-satir {
  display: grid;
  grid-template-columns: minmax(70px, 36%) 1fr auto;
  align-items: center;
  gap: 8px;
  padding: 3px 2px;
  font-size: 12px;
  cursor: pointer;
  border-radius: 4px;
}
.bi-demo .bi-cubuk-satir:hover {
  background: rgba(22, 119, 255, 0.06);
}
.bi-demo .bi-cubuk-etiket {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bi-demo .bi-cubuk-iz {
  height: 14px;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.05);
  overflow: hidden;
}
body.dark-theme .bi-demo .bi-cubuk-iz {
  background: rgba(255, 255, 255, 0.08);
}
.bi-demo .bi-cubuk-dolgu {
  height: 100%;
  border-radius: 3px;
  opacity: 0.85;
}
.bi-demo .bi-cubuk-deger {
  min-width: 112px;
  text-align: right;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

/* Harita */
.bi-demo .bi-harita-sarmal {
  position: relative;
}
.bi-demo .bi-harita {
  width: 100%;
  height: 600px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #eef0f2;
}
.bi-demo .bi-harita-yukleniyor {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.45);
  border-radius: 8px;
  z-index: 2;
}
body.dark-theme .bi-demo .bi-harita-yukleniyor {
  background: rgba(0, 0, 0, 0.35);
}
body.dark-theme .bi-demo .bi-harita {
  border-color: rgba(255, 255, 255, 0.08);
}

/* Kontrol satır vurgusu */
.bi-demo .bi-kontrol-hata > td {
  background: #fff1f0 !important;
}
.bi-demo .bi-kontrol-uyari > td {
  background: #fff7e6 !important;
}
body.dark-theme .bi-demo .bi-kontrol-hata > td {
  background: rgba(255, 77, 79, 0.14) !important;
}
body.dark-theme .bi-demo .bi-kontrol-uyari > td {
  background: rgba(250, 173, 20, 0.14) !important;
}

@media (max-width: 767px) {
  .nf-module.bi-demo {
    padding: 8px;
  }
  .bi-demo .bi-harita {
    height: 420px;
  }
  .bi-demo .bi-cubuk-deger {
    min-width: 92px;
  }
  .bi-demo .bi-suzgec .ant-select,
  .bi-demo .bi-suzgec .ant-input-search {
    max-width: calc(100vw - 48px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/bi/BiDemoPage.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;EACE,YAAY;EACZ,6CAA6C;EAC7C,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,6CAA6C;AAC/C;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,iDAAiD;EACjD,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,+BAA+B;AACjC;AACA;EACE,uCAAuC;AACzC;;AAEA,0BAA0B;AAC1B;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;AACjD;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;;IAEE,6BAA6B;EAC/B;AACF","sourcesContent":["/* BI v2 teyit ekranı (/bi-demo) */\n\n.bi-demo .bi-kpi-kart {\n  height: 100%;\n  border-top: 3px solid var(--bi-renk, #8c8c8c);\n  cursor: pointer;\n  transition: box-shadow 0.15s ease;\n}\n.bi-demo .bi-kpi-kart.pasif {\n  cursor: default;\n  opacity: 0.75;\n}\n.bi-demo .bi-kpi-kart.secili {\n  box-shadow: 0 0 0 2px var(--bi-renk, #1677ff);\n}\n.bi-demo .bi-kpi-baslik {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n  margin-bottom: 6px;\n}\n.bi-demo .bi-kpi-tutar {\n  font-size: 19px;\n  font-weight: 600;\n  line-height: 1.3;\n  font-variant-numeric: tabular-nums;\n  word-break: break-word;\n}\n.bi-demo .bi-nokta {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex: none;\n}\n.bi-demo .bi-panel {\n  border-top: 3px solid var(--bi-renk, #8c8c8c);\n}\n\n/* Süzgeçler */\n.bi-demo .bi-suzgec {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.bi-demo .bi-suzgec-ad {\n  font-size: 11px;\n  color: #8c8c8c;\n  line-height: 1.2;\n}\n.bi-demo .bi-suzgec-cubugu {\n  padding: 10px;\n  margin-bottom: 8px;\n  border-radius: 8px;\n  background: #f7f9fb;\n  border: 1px solid #eef0f2;\n}\n.bi-demo .bi-etiketler {\n  margin-top: 8px;\n}\nbody.dark-theme .bi-demo .bi-suzgec-cubugu {\n  background: rgba(255, 255, 255, 0.04);\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n/* Özet: yatay çubuklar (ilk 15 grup) */\n.bi-demo .bi-cubuk-kutu {\n  padding: 10px;\n  border: 1px solid #eef0f2;\n  border-radius: 10px;\n}\nbody.dark-theme .bi-demo .bi-cubuk-kutu {\n  border-color: rgba(255, 255, 255, 0.08);\n}\n.bi-demo .bi-cubuk-satir {\n  display: grid;\n  grid-template-columns: minmax(70px, 36%) 1fr auto;\n  align-items: center;\n  gap: 8px;\n  padding: 3px 2px;\n  font-size: 12px;\n  cursor: pointer;\n  border-radius: 4px;\n}\n.bi-demo .bi-cubuk-satir:hover {\n  background: rgba(22, 119, 255, 0.06);\n}\n.bi-demo .bi-cubuk-etiket {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.bi-demo .bi-cubuk-iz {\n  height: 14px;\n  border-radius: 3px;\n  background: rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n}\nbody.dark-theme .bi-demo .bi-cubuk-iz {\n  background: rgba(255, 255, 255, 0.08);\n}\n.bi-demo .bi-cubuk-dolgu {\n  height: 100%;\n  border-radius: 3px;\n  opacity: 0.85;\n}\n.bi-demo .bi-cubuk-deger {\n  min-width: 112px;\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n/* Harita */\n.bi-demo .bi-harita-sarmal {\n  position: relative;\n}\n.bi-demo .bi-harita {\n  width: 100%;\n  height: 600px;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #eef0f2;\n}\n.bi-demo .bi-harita-yukleniyor {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.45);\n  border-radius: 8px;\n  z-index: 2;\n}\nbody.dark-theme .bi-demo .bi-harita-yukleniyor {\n  background: rgba(0, 0, 0, 0.35);\n}\nbody.dark-theme .bi-demo .bi-harita {\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n/* Kontrol satır vurgusu */\n.bi-demo .bi-kontrol-hata > td {\n  background: #fff1f0 !important;\n}\n.bi-demo .bi-kontrol-uyari > td {\n  background: #fff7e6 !important;\n}\nbody.dark-theme .bi-demo .bi-kontrol-hata > td {\n  background: rgba(255, 77, 79, 0.14) !important;\n}\nbody.dark-theme .bi-demo .bi-kontrol-uyari > td {\n  background: rgba(250, 173, 20, 0.14) !important;\n}\n\n@media (max-width: 767px) {\n  .nf-module.bi-demo {\n    padding: 8px;\n  }\n  .bi-demo .bi-harita {\n    height: 420px;\n  }\n  .bi-demo .bi-cubuk-deger {\n    min-width: 92px;\n  }\n  .bi-demo .bi-suzgec .ant-select,\n  .bi-demo .bi-suzgec .ant-input-search {\n    max-width: calc(100vw - 48px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
